import { NumberValue, ScaleLinear, scaleLinear } from 'd3-scale';
import { useMemo } from 'react';
import { Scale } from '../types/scale';

interface Scope {
  start?: number;
  end: number;
}

interface Props {
  domain: Scope;
  range: Scope;
}

// we use the `as TypedScaleLinear` typing because d3 recently edited the type definition
// for d3 scale to add `undefined` as a possible return value type, which breaks almost everywhere
export interface TypedScaleLinear<Range, Output>
  extends ScaleLinear<Range, Output> {
  (value: NumberValue): Output;
}

export const useScale = ({
  domain: { start: domainStart = 0, end: domainEnd },
  range: { start: rangeStart = 0, end: rangeEnd },
}: Props) =>
  useMemo(
    () =>
      scaleLinear()
        .domain([domainStart, domainEnd])
        .range([rangeStart, rangeEnd]),
    [domainStart, domainEnd, rangeStart, rangeEnd],
  ) as TypedScaleLinear<number, number>;

export const MAX_AMPLITUDE = 2; // mV;

export const resetScale = (yScale: Scale) =>
  yScale.copy().domain([0, MAX_AMPLITUDE]) as TypedScaleLinear<number, number>;
